import React from 'react';
import { components } from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { MdKeyboardArrowRight } from 'react-icons/md';

import './Dropdown.scss';

export type CreatableDropdownProps = {
    options?: string[];
    onOptionChange: (option: string[]) => void;
    value?: string[] | null | undefined;
    menuIsOpen?: boolean;
    required?: boolean;
    label?: string;
    disabled?: boolean;
    isSearchable?: boolean;
    name?: string;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const DropdownIndicator = (props: any) => {
    return (
        <components.DropdownIndicator {...props}>
            <MdKeyboardArrowRight fontSize={28} />
        </components.DropdownIndicator>
    );
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ValueContainer = ({ children, ...props }: any) => {
    return (
        <components.ValueContainer {...props}>
            <div className="dropdown__label">
                {props.selectProps.placeholder}
            </div>
            {children}
        </components.ValueContainer>
    );
};

export const CreatableDropdown: React.FC<CreatableDropdownProps> = ({
    options = [],
    onOptionChange,
    label,
    value,
    menuIsOpen,
    disabled = false,
    name,
    required = false
}) => {

    return (<>
        <CreatableSelect
            name={name}
            required={required}
            options={options.map((v) => ({label: v, value: v}))}
            className="dropdown"
            classNamePrefix="dropdown"
            components={{ 
                DropdownIndicator,
                ValueContainer
            }}
            isMulti
            placeholder={label + (required ? ' *' : '')}
            onChange={(option) => {onOptionChange(option.map((v) => v.value))}}
            menuIsOpen={menuIsOpen}
            value={value?.map((v) => ({label: v, value: v}))}
            isClearable
            isDisabled={disabled}
        />
    </>);
};
